export default (theme) => {
  const colors = theme.palette.common

  return {
    root: ({ color, variant }) => {
      const padding = theme.spacing(0.7, 2.4)

      const containedVariant = variant === 'contained' && {
        backgroundColor: colors[color],
        color: colors.white,
        '&:hover': {
          backgroundColor: colors[color],
        },
        borderRadius: '2rem',
        padding,
        ...(color === 'white' && {
          color: colors.primary,
          border: `1px solid ${colors.primary}`,
        }),
      }

      const outlinedVariant = variant === 'outlined' && {
        backgroundColor: 'unset',
        color: colors[color],
        '&:hover': {
          backgroundColor: 'unset',
        },
        borderRadius: '2rem',
        border: `1px solid ${colors[color]}`,
        padding,
      }

      const textVariant = variant === 'text' && {
        backgroundColor: 'unset',
        color: colors[color],
        '&:hover': {
          backgroundColor: 'unset',
        },
        borderRadius: '2rem',
        border: 'unset',
        padding,
      }

      return {
        ...containedVariant,
        ...outlinedVariant,
        ...textVariant,
      }
    },

    loadingContainer: {
      top: 0,
      left: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      display: 'flex',
    },

    loading: ({ variant, color }) => {
      let iconColor = colors[color]
      if (variant === 'contained') {
        iconColor = color === 'white' ? colors.primary : colors.white
      }
      return {
        color: iconColor,
      }
    },

    label: ({ loading }) => {
      // to make the loading button to be the same size with text button
      return loading && {
        whiteSpace: 'pre',
        '&:after': {
          content: '" "',
        },
        '&:before': {
          content: '" "',
        },
      }
    },

    childrenWrap: ({ loading }) => {
      if (loading) {
        return {
          opacity: 0,
        }
      }

      return {
        display: 'flex',
        alignItems: 'center',
      }
    },
  }
}
